var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0735 14.839L13.6493 8.54454C14.4388 7.78886 14.4388 6.5636 13.6493 5.80788C12.8598 5.05217 11.5798 5.05217 10.7903 5.80788L4.26214 12.0567C2.7621 13.4925 2.7621 15.8205 4.26214 17.2564C5.76218 18.6923 8.19423 18.6923 9.69425 17.2564L16.3177 10.9164C18.5283 8.80037 18.5283 5.36964 16.3177 3.25363C14.1071 1.13762 10.523 1.13762 8.31241 3.25363L2.97559 8.36212",
    stroke: "#313131",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.4ee9f5b0f6831ba294d26d05bef95988.svg";
export { ForwardRef as ReactComponent };